import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M20 7H15V2L20 7Z" fill="currentColor" />
    <path
      d="M14 8V2H6.286C5.023 2 4 2.895 4 4V20C4 21.105 5.023 22 6.286 22H17.715C18.977 22 20 21.105 20 20V8H14ZM6.708 19.059C6.708 19.059 8.81 16.106 9.181 15.54C9.552 14.974 10.007 15.105 10.325 15.559C10.448 15.735 10.59 15.937 10.717 16.12C10.919 16.409 11.249 16.419 11.491 16.081C12.032 15.322 12.963 14.006 13.311 13.455C13.815 12.659 14.339 12.69 14.856 13.429C15.044 13.698 17.553 17.283 17.553 17.283C17.553 17.283 17.555 18.007 17.555 18.402C17.555 18.797 17.358 19.049 16.94 19.049C16.522 19.049 6.708 19.059 6.708 19.059V19.059ZM10.375 11.422C10.375 12.285 9.675 12.984 8.813 12.984C7.951 12.984 7.251 12.284 7.251 11.422C7.251 10.559 7.951 9.859 8.813 9.859C9.675 9.859 10.375 10.559 10.375 11.422Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'FileGraphic');

export default Icon;
